import settings from './modules/settings/Settings';
import user from './modules/user/User';
import escorter from './modules/escorter/Escorter';
import theme from './modules/theme/Theme';
import support from './modules/Support';
import userAndRoles from './modules/user/UserRoles';
import notificationSettings from './modules/settings/NotificationSettings';
import selects from './modules/selects/Select';
import clientScope from './modules/clientScope/ClientScope';

export default{
    modules: {
        theme,
        settings,
        user,
        clientScope,
        escorter,
        userAndRoles,
        notificationSettings,
        support,
        selects,
    }
}
